import { useEffect } from 'react';
import Cookies from 'js-cookie';
export var useInitLWAPI = function useInitLWAPI(options) {
  var isOpen = options.isOpen,
      handleClose = options.handleClose,
      ssdcpName = options.ssdcpName,
      setIsOpen = options.setIsOpen;
  useEffect(function () {
    if (typeof window !== 'undefined') {
      window.lwapi = window.lwapi || {
        callback: [],
        close: function close() {
          handleClose();
        },
        isAuth: function isAuth() {
          return !!Cookies.get(ssdcpName);
        },
        isOpen: function (_isOpen) {
          function isOpen() {
            return _isOpen.apply(this, arguments);
          }

          isOpen.toString = function () {
            return _isOpen.toString();
          };

          return isOpen;
        }(function () {
          return isOpen;
        }),
        open: function open(callback) {
          var _window$lwapi;

          (_window$lwapi = window.lwapi) === null || _window$lwapi === void 0 ? void 0 : _window$lwapi.callback.push(callback);
          setIsOpen(true);
        }
      };
    }

    return function () {
      if (typeof window !== 'undefined' && 'lwapi' in window) {
        delete window.lwapi;
      }
    };
  }, []);
};